module.exports = "http://cdn.realive.com.ua/src/views/player/documets/lspdbadge/images/6.png";